export type SerializedUserPermission = {
  user_id: number;
  access_level: number;
};

export type SerializedGroupPermission = {
  group_id: number;
  access_level: number;
};

export function serializeUserPermissionsMap(
  map: Map<number, number>
): SerializedUserPermission[] {
  return Array.from(map.entries()).map(([user_id, access_level]) => ({
    user_id,
    access_level,
  }));
}

export function serializeUserPermissionsMapWithout(
  map: Map<number, number>,
  userId: number
): SerializedUserPermission[] {
  const filtered = new Map(map);
  filtered.delete(userId);
  return serializeUserPermissionsMap(filtered);
}

export function serializeGroupPermissionsMap(
  map: Map<number, number>
): SerializedGroupPermission[] {
  return Array.from(map.entries()).map(([group_id, access_level]) => ({
    group_id,
    access_level,
  }));
}

export function serializeGroupPermissionsMapWithout(
  map: Map<number, number>,
  groupId: number
): SerializedGroupPermission[] {
  const filtered = new Map(map);
  filtered.delete(groupId);
  return serializeGroupPermissionsMap(filtered);
}
